/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tick': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M9.374 22.91c-1.992-1.758-5.134-1.674-7.015.187-1.888 1.855-1.797 4.782.2 6.534l14.896 13.104c2.127 1.878 5.528 1.632 7.326-.518l23.171-27.75c1.687-2.017 1.293-4.925-.866-6.49-2.166-1.573-5.289-1.205-6.97.806L20.3 32.516 9.374 22.91z" _fill="#29A8E3" fill-rule="evenodd"/>'
  }
})
